<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-format-list-checkbox"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="12" class="content_showroom rounded-lg">
          <v-row class="mx-3">
            <v-col cols="6">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Tên showroom"
                v-model="showroom.name"
                placeholder="Nhập tên showroom"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Slug"
                v-model="showroom.slug"
                placeholder="Nhập slug"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-select
                background-color="#EDF2F7"
                filled
                :items="areas"
                item-text="name"
                item-value="id"
                v-model="showroom.area_id"
                label="Chọn khu vực"
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                background-color="#EDF2F7"
                filled
                :items="provinces"
                item-text="name"
                item-value="id"
                v-model="showroom.province_id"
                label="Chọn tỉnh thành"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                background-color="#EDF2F7"
                filled
                :items="districts"
                item-text="name"
                item-value="id"
                v-model="showroom.district_id"
                label="Chọn quận huyện"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                background-color="#EDF2F7"
                filled
                :items="wards"
                item-text="name"
                item-value="id"
                v-model="showroom.ward_id"
                label="Chọn phường xã"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Địa chỉ"
                v-model="showroom.address"
                placeholder="Nhập địa chỉ"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Tọa độ X (địa chỉ)"
                v-model="showroom.lat"
                placeholder="Nhập tọa độ X"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Tọa độ Y (địa chỉ)"
                v-model="showroom.long"
                placeholder="Nhập tọa độ Y"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Thời gian bắt đầu làm việc"
                v-model="showroom.start_work_time"
                placeholder="Nhập thời gian kết thúc làm việc"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Thời gian kết thúc làm việc"
                v-model="showroom.end_work_time"
                placeholder="Nhập thời gian kết thúc làm việc"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Tel"
                v-model="showroom.phone"
                placeholder="Nhập tel"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Hotline"
                v-model="showroom.hotline"
                placeholder="Nhập hotline"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Website"
                v-model="showroom.website"
                placeholder="Website"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                background-color="#EDF2F7"
                filled
                :items="supports"
                item-text="fullname"
                item-value="id"
                v-model="showroom.support_id"
                label="Chọn cửa hàng trưởng"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Độ ưu tiên"
                v-model="showroom.order"
                placeholder="Độ ưu tiên"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-select
                background-color="#EDF2F7"
                filled
                :items="brands"
                item-text="name"
                item-value="id"
                label="Chọn brand"
                v-model="showroom.brand_ids"
                multiple
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="mx-3">
            <v-col cols="12">
              <v-select
                  background-color="#EDF2F7"
                  filled
                  :items="config_showroom"
                  item-text="name"
                  item-value="id"
                  label="Chọn loại showroom"
                  v-model="showroom.types"
                  chips
                  multiple
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="mx-3">
            <v-col cols="6">
              <v-file-input

                  label="Ảnh đầu tiên (desktop)"
                  placeholder="Tải ảnh lên"
                  prepend-icon="mdi-camera"
                  @change="uploadFirstImage($event)"
              ></v-file-input>
            </v-col>
            <v-col cols="6"></v-col>
            <v-col cols="12">
              <div  class="box-image" v-if="showroom.first_photo_url">
                <div  class="item-image">
                  <v-img
                      height="150"
                      width="150"
                      :src="showroom.first_photo_url"

                  ></v-img>
                </div>
              </div>
            </v-col>

            <v-col cols="6">
              <v-file-input

                  label="Ảnh đầu tiên (mobile)"
                  placeholder="Tải ảnh lên"
                  prepend-icon="mdi-camera"
                  @change="uploadFirstImageMobile($event)"
              ></v-file-input>
            </v-col>
            <v-col cols="6"></v-col>
            <v-col cols="12">
              <div  class="box-image" v-if="showroom.first_photo_url_mobile">
                <div  class="item-image">
                  <v-img
                      height="150"
                      width="150"
                      :src="showroom.first_photo_url_mobile"

                  ></v-img>
                </div>
              </div>
            </v-col>

            <v-col cols="12">
              <v-textarea
                  v-model="showroom.first_description"
                  background-color="#EDF2F7"
                  filled
                  label="Mô tả ngắn"
                  placeholder="Nhập mô tả ngắn"
              >
              </v-textarea>
            </v-col>
          </v-row>
<!--            <v-row class="mx-3">-->
<!--              <v-col cols="6">-->
<!--                <v-file-input-->
<!--                    multiple-->
<!--                    label="Ảnh desktop"-->
<!--                    placeholder="Tải ảnh lên"-->
<!--                    prepend-icon="mdi-camera"-->
<!--                    @change="uploadImage($event, 0)"-->
<!--                ></v-file-input>-->
<!--              </v-col>-->
<!--              <v-col cols="6"></v-col>-->
<!--              <v-col cols="12">-->
<!--                <div v-for="(img,index) in list_imgs" :key="img.id" class="box-image">-->
<!--                  <div v-if="img.type == 0" class="item-image">-->
<!--                    <v-img-->
<!--                        height="150"-->
<!--                        width="150"-->
<!--                        :src="img.url_image"-->

<!--                    ></v-img>-->
<!--                    <v-text-field -->
<!--                        background-color="#EDF2F7"-->
<!--                        filled-->
<!--                        label="Alt ảnh"-->
<!--                        v-model="img.alt_image"-->
<!--                        placeholder="Nhập alt"-->
<!--                    ></v-text-field>-->
<!--                    <v-btn-->
<!--                        @click="clearImg(index)"-->
<!--                        x-small-->
<!--                        outlined-->
<!--                        fab-->
<!--                        color="red"-->
<!--                        class="float-right mt-1"-->
<!--                    >-->
<!--                      <v-icon>mdi-close</v-icon>-->
<!--                    </v-btn>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </v-col>-->
<!--            </v-row>-->
<!--            <v-row class="mx-3">-->
<!--              <v-col cols="6">-->
<!--                <v-file-input-->
<!--                    multiple-->
<!--                    label="Ảnh mobile"-->
<!--                    placeholder="Tải ảnh lên"-->
<!--                    prepend-icon="mdi-camera"-->
<!--                    @change="uploadImage($event, 1)"-->
<!--                ></v-file-input>-->
<!--              </v-col>-->
<!--              <v-col cols="12">-->
<!--                <div v-for="(img,index) in list_imgs" :key="img.id" class="box-image">-->
<!--                  <div v-if="img.type == 1" class="item-image">-->
<!--                    <v-img-->
<!--                        height="150"-->
<!--                        width="150"-->
<!--                        :src="img.url_image"-->

<!--                    ></v-img>-->
<!--                    <v-text-field -->
<!--                        background-color="#EDF2F7"-->
<!--                        filled-->
<!--                        label="Alt ảnh"-->
<!--                        v-model="img.alt_image"-->
<!--                        placeholder="Nhập alt"-->
<!--                    ></v-text-field>-->

<!--                    <v-btn-->
<!--                        @click="clearImg(index)"-->
<!--                        x-small-->
<!--                        outlined-->
<!--                        fab-->
<!--                        color="red"-->
<!--                        class="float-right mt-1"-->
<!--                    >-->
<!--                      <v-icon>mdi-close</v-icon>-->
<!--                    </v-btn>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </v-col>-->
<!--            </v-row>-->
            <v-col>
              <ck-content label="Mô tả" placeholder="Nhập tên mô tả" class="content-textarea mx-3" :content="showroom.description" @getData="value => showroom.description = value"/>
            </v-col>
        </v-col>
        <v-col cols="12" class="content_showroom rounded-lg mt-3 hide">
          <v-row class="mx-3">
            <v-col cols="12">
              <span
                >Giới thiệu showroom
                <v-btn color="primary" icon @click="addBlock">
                  <v-icon>mdi-plus-box</v-icon>
                </v-btn>
              </span>
            </v-col>
          </v-row>
          <v-row
            class="mx-3"
            v-for="(intro, index) in showroom.list_store_description"
            :key="index"
          >
            <v-col cols="6">
              <v-file-input
                label="Ảnh"
                placeholder="Tải ảnh lên"
                prepend-icon="mdi-camera"
                @change.self="fileSelected($event, index)"
              ></v-file-input>
              <v-img
                :src="intro.url"
                height="200px"
                width="200px"
                contain
              ></v-img>
            </v-col>
            <v-col cols="6">
              <div class="d-flex justify-end">
                <v-btn
                  class="ma-2"
                  outlined
                  large
                  color="indigo"
                  @click="clearDesciption(index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
              <v-textarea
                class="content-textarea"
                background-color="#EDF2F7"
                filled
                v-model="intro.description"
                label="Mô tả"
                placeholder="Nhập tên mô tả"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn color="primary" width="180" @click="save_category()">
            Lưu
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { UPLOAD_SHOWROOM_IMAGE, SAVE_SHOWROOM } from "@/store/modules/showroom";
import { GET_LIST_SUPPORT } from "@/store/modules/support";
import {
  GET_LIST_AREAS,
  GET_LIST_DISTRICTS,
  GET_LIST_PROVINCES,
  GET_LIST_WARDS,
} from "@/store/modules/residence";
import { GET_LIST_BRAND } from "@/store/modules/brand";
// import {UPLOAD} from '@/store/modules/upload'
import { mapGetters } from "vuex";
import CkContent from "@/components/ck-content"
import { replaceCkContent } from '@/utils/helpers'
export default {
  components: {
    CkContent
  },
  data() {
    return {
      list_imgs:[],
      src: "",
      image: {},
      hasImage: false,
      selectedFile: null,
      showroom: {
        order: 0,
        name: "",
        area_id: null,
        province_id: null,
        district_id: null,
        ward_id: null,
        description: "",
        address: "",
        slug: "",
        lat: "",
        long: "",
        phone: "",
        hotline: "",
        support_id: null,
        start_work_time: "",
        end_work_time: "",
        brand_ids :[],
        list_store_description: [],
        list_media: [],
        website: '',
      },
      config_showroom: [
        {
          id:0, name: "Showroom chính hãng"
        },
        {
          id:1, name: "Showroom ủy quyền"
        },
        {
          id:2, name: "Điểm giao dịch"
        },
        {
          id:3, name: "Showroom thiết kế kiến trúc"
        },
      ],
      page: "Quản lý showroom",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý showroom",
          disabled: true,
        },
        {
          text: "Quản lý showroom",
          disabled: true,
        },
        {
          text: "Thêm showroom",
          disabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      areas: "areas",
      provinces: "provinces",
      districts: "districts",
      wards: "wards",
      supports: "supports",
      brands: "brands",
    }),
  },
  watch: {
    "showroom.area_id": function (val) {
      this.$store.dispatch(`${GET_LIST_PROVINCES}`, val);
    },
    "showroom.province_id": function (val) {
      this.$store.dispatch(`${GET_LIST_DISTRICTS}`, val);
    },
    "showroom.district_id": function (val) {
      this.$store.dispatch(`${GET_LIST_WARDS}`, val);
    },
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_AREAS}`);
    await this.$store.dispatch(`${GET_LIST_SUPPORT}`);
       await this.$store.dispatch(`${GET_LIST_BRAND}`);
  },
  methods: {
    uploadFirstImage(event){
      const _this = this;
        // this.production.list_media = []
        let formData = new FormData();

          formData.append("upload", event);
          formData.append("type", "stores");
      this.$store.dispatch(`${UPLOAD_SHOWROOM_IMAGE}`,formData).then((data) => {
            data.data.data.forEach(el => {
              _this.showroom.first_photo_url = el.url
            })
            this.$forceUpdate();
          })
    },
    uploadFirstImageMobile(event){
      const _this = this;
        // this.production.list_media = []
        let formData = new FormData();

          formData.append("upload", event);
          formData.append("type", "stores");
      this.$store.dispatch(`${UPLOAD_SHOWROOM_IMAGE}`,formData).then((data) => {
            data.data.data.forEach(el => {
              _this.showroom.first_photo_url_mobile = el.url
            })
            this.$forceUpdate();
          })
    },
    uploadImage(event, type = 0){
      const _this = this;
      if (!event) {
        this.list_media = []
      } else {
        // this.production.list_media = []
        let formData = new FormData();

        event.forEach(element => {
          formData.append("upload", element);
          formData.append("type", "stores");
          _this.$store.dispatch(`${UPLOAD_SHOWROOM_IMAGE}`,formData).then((data) => {
            data.data.data.forEach(el => {
              _this.list_imgs.push({
                id: el.media_id,
                url_image: el.url,
                url: el.path,
                type: type,
                alt_image: ""
              })
            })
          })
        })
      }
    },
    clearImg(index){
      this.list_imgs.splice(index, 1)
      this.showroom.list_media.splice(index, 1)
      this.$forceUpdate()
    },
    clearDesciption(index) {
      this.showroom.list_store_description.splice(index, 1);
      this.$forceUpdate();
    },
    addBlock() {
      this.showroom.list_store_description.push({
        url: "",
        description: "",
      });
      this.$forceUpdate();
    },
    clearBlock(i, index) {
      this.showroom.list_store_description.splice(index, 1);
      this.$forceUpdate();
    },
    fileSelected: function (event, index) {
      if (!event) {
        this.src = "";
      }
      this.image = event;
      this.src = URL.createObjectURL(this.image);
      if (this.image) {
        this.hasImage = !this.hasImage;
      }
      let formData = new FormData();
      formData.append("upload", this.image);
      formData.append("type", "stores");
      this.$store
        .dispatch(`${UPLOAD_SHOWROOM_IMAGE}`, formData)
        .then((data) => {
          if (data && data.data && data.data.data) {
            data.data.data.forEach((element) => {
              let intro = this.showroom.list_store_description.find(
                (element, i) => i == index
              );
              intro.url = element.url;
            });
          }
        });
    },
    async save_category() {
      let data_showroom = {
        name: this.showroom.name,
        ward_id: this.showroom.ward_id,
        address: this.showroom.address,
        slug: this.showroom.slug,
        lat: this.showroom.lat,
        long: this.showroom.long,
        phone: this.showroom.phone,
        hotline: this.showroom.hotline,
        description: replaceCkContent(this.showroom.description),
        support_id: this.showroom.support_id,
        brand_ids : JSON.stringify(this.showroom.brand_ids),
        start_work_time: this.showroom.start_work_time,
        end_work_time: this.showroom.end_work_time,
        website: this.showroom.website,
        list_store_description: JSON.stringify(
          this.showroom.list_store_description
        ),
        list_media: JSON.stringify(
            this.list_imgs
        ),
        types: JSON.stringify(this.showroom.types),
        first_photo_url: this.showroom.first_photo_url,
        first_description: this.showroom.first_description,
        first_photo_url_mobile: this.showroom.first_photo_url_mobile,
      };
      await this.$store
        .dispatch(`${SAVE_SHOWROOM}`, data_showroom)
        .then((data) => {
          if (data.data.status == 1) {
            this.$toasted.success('Cập nhật thành công!', {
              duration:1000,
              position:'top-center'
            })
            this.$router.push("/show_room");
          } else {
            alert(data.data.errors);
          }
        });
    },
  },
};
</script>
<style lang="scss">
.content_showroom {
  background: #ffffff !important;
  .content-textarea .v-input__control {
    height: 165px !important;
  }
}
.box-image{
  display: inline-block;
  .item-image{
    margin-right:10px;
    width: 150px;
    object-fit: contain;
    display: inline-block;
  }
}
</style>